import { staffAPI } from '../services/api';

const getLeaveTypeName = (leave) => (
  leave?.leave_type?.leave_type_name
  || leave?.leave_type_name
  || leave?.leave_type_id?.leave_type_name
  || ''
);

export const isNationalServiceLeave = (leave) => (
  getLeaveTypeName(leave).toLowerCase().includes('national service')
);

export const isAcknowledgedNsLeave = (leave) => (
  isNationalServiceLeave(leave) && Boolean(leave?.ro_acknowledged_at)
);

export const withoutAcknowledgedNsLeave = (items) => (
  (Array.isArray(items) ? items : []).filter((leave) => !isAcknowledgedNsLeave(leave))
);

/**
 * Fetch the reporting officer's actionable leave inbox.
 *
 * The dedicated endpoint is authoritative for single-level, multi-level, and
 * NS acknowledgement routing. A former empty-result fallback to all team
 * leaves reintroduced acknowledged NS rows because acknowledgement does not
 * change their submitted leave status.
 */
export const fetchRoPendingApprovals = async () => {
  const response = await staffAPI.getPendingLeaveApplications(true);
  const items = response.data?.results || response.data || [];
  return withoutAcknowledgedNsLeave(items);
};
